import '@firebase/performance';
//# sourceMappingURL=index.esm.js.map



// WEBPACK FOOTER //
// ../node_modules/firebase/performance/dist/index.esm.js